import React from "react";
import { Seo, Section, SectionHead } from "./Ui";

const PRIVACY = [
  ["Information we collect", "When you contact DREZORO we collect the details you provide: your name, email address, company, and message. Our websites collect standard technical information such as browser type and pages visited, used solely to operate and improve the site."],
  ["How we use information", "We use contact information exclusively to respond to your enquiry and manage business relationships. We do not sell, rent, or trade personal information to third parties."],
  ["Data retention & security", "Contact submissions are stored securely with access restricted to authorized DREZORO personnel. You may request deletion of your data at any time by emailing info@drezoro.com."],
  ["Our companies", "DREZORO group companies (including Vozelto) operate their own products with their own privacy policies. This policy covers the DREZORO corporate website only."],
  ["Contact", "Privacy questions: info@drezoro.com."],
];

const TERMS = [
  ["Use of this website", "The DREZORO corporate website is provided for informational purposes about the DREZORO group and its companies. You may not misuse the site, attempt unauthorized access, or reproduce its content for commercial purposes without written permission."],
  ["Intellectual property", "DREZORO, VOZELTO, and associated marks, logos, and content are the property of DREZORO and its group companies. All rights reserved."],
  ["No offer or advice", "Nothing on this website constitutes an offer of securities, investment advice, or a binding commitment. Product capabilities described refer to group company platforms governed by their own agreements."],
  ["Limitation of liability", "This website is provided \"as is\" without warranties of any kind. To the maximum extent permitted by law, DREZORO is not liable for damages arising from use of this site."],
  ["Contact", "Questions about these terms: info@drezoro.com."],
];

export default function DrezoroLegal({ kind = "privacy" }) {
  const isPrivacy = kind === "privacy";
  const rows = isPrivacy ? PRIVACY : TERMS;
  const title = isPrivacy ? "Privacy Policy" : "Terms of Service";
  return (
    <div data-testid={`drezoro-${kind}`}>
      <Seo title={`${title} — DREZORO`} description={`DREZORO corporate website ${title.toLowerCase()}.`} />
      <Section>
        <SectionHead label="Legal" title={title} intro={`Effective ${new Date().getFullYear()} — applies to the DREZORO corporate website.`} />
        <div className="max-w-3xl space-y-8">
          {rows.map(([t, d]) => (
            <div key={t}>
              <h2 className="text-lg font-medium text-white">{t}</h2>
              <p className="mt-2 text-sm md:text-base text-zinc-400 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
